<script setup>
import Navbar from '@/components/NavbarView.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import InnovationIcon from '@/assets/svg/sti.svg'
import { Checked, List, User, DataAnalysis, Bell, Reading, TrophyBase, Opportunity } from '@element-plus/icons-vue';

const route = useRoute()
const onRoutes = computed(() => {
  return route.path
})
</script>

<template>
  <div>
    <Navbar :showMenu="false" />
    <el-row class="tac">
      <el-col :span="3" style="margin-top: 60px;">
        <el-menu router :default-active="onRoutes">
          <!-- <el-menu-item index="/overview">
            <el-icon><DataAnalysis /></el-icon>
            <span>数据概览</span>
          </el-menu-item> -->
          <el-menu-item index="/notice-manage">
            <el-icon><Bell /></el-icon>
            <span>公告管理</span>
          </el-menu-item>
          <el-menu-item index="/activity-manage">
            <el-icon><List /></el-icon>
            <span>赛事管理</span>
          </el-menu-item>
          <el-menu-item index="/sti-manage">
            <!-- <el-icon><List /></el-icon> -->
            <!-- <InnovationIcon class="icon" /> -->
            <el-icon><Opportunity /></el-icon>
            <!-- <img src="@/assets/svg/sti.svg" alt="科创管理图标" style="width: 24px; height: 18px; margin-right: 5px;"> -->
            <span>科创管理</span>
          </el-menu-item>
          <!-- <el-menu-item index="/event-manage">
            <el-icon><TrophyBase /></el-icon>
            <span>赛事管理</span>
          </el-menu-item> -->
          <!-- <el-menu-item index="/results">
            <el-icon><checked /></el-icon>
            <span>查看评审结果</span>
          </el-menu-item> -->
          <!-- <el-menu-item index="/course-manage">
            <el-icon><Reading /></el-icon>
            <span>课程管理</span>
          </el-menu-item> -->
          <el-menu-item index="/user-manage">
            <el-icon><User /></el-icon>
            <!-- <el-icon><UserFilled /></el-icon> -->
            <span>用户管理</span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="21">
        <div class="content-box">
          <router-view />
        </div>
        <!-- <router-view /> -->
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>

</style>
